import { moodColor } from "@/lib/api";

export function MoodPill({ mood, score }) {
  const c = moodColor(mood);
  return (
    <span
      className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium"
      style={{ backgroundColor: `${c}22`, color: "#2A3326" }}
      data-testid={`mood-pill-${mood}`}
    >
      <span className="w-2 h-2 rounded-full" style={{ backgroundColor: c }} />
      {mood}
      {typeof score === "number" && (
        <span className="text-ink-500 font-normal">
          {score > 0 ? "+" : ""}
          {score.toFixed(2)}
        </span>
      )}
    </span>
  );
}

export function EmotionTag({ tag }) {
  return (
    <span
      className="inline-block px-2.5 py-0.5 rounded-full text-[11px] uppercase tracking-wider text-ink-700 border border-bone-300 bg-bone-200/60"
      data-testid={`emotion-tag-${tag}`}
    >
      {tag}
    </span>
  );
}
